import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en/common.json';
import ko from './locales/ko/common.json';

// 리소스 타입 정의
export const resources = {
  en: {
    translation: en,
  },
  ko: {
    translation: ko,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ko',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // escape 방지("/" 등 특수문자)
    },
    detection: {
      order: ['localStorage', 'navigator'], // localStorage를 먼저 확인하도록 설정
      lookupLocalStorage: 'i18nextLng', // localStorage에서 사용할 키 이름
      caches: ['localStorage'], // 언어 설정을 캐시할 위치
      convertDetectedLanguage: (lng) => {
        return lng.split('-')[0]; // 'ko-KR' -> 'ko', 'en-US' -> 'en'
      },
    },
  });
// 타입 선언 수정
declare module 'i18next' {
  interface CustomTypeOptions {
    // defaultNS: 'translation';
    resources: typeof resources;
  }
}

export default i18n;
